import React from 'react';
import { FloatButton } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Configuración de DayJS para manejo de zonas horarias
dayjs.extend(utc);
dayjs.extend(timezone);

const ClickToCallWidget = () => {
  const callUrl =
    'https://nuatechnology.ras.uccpbx.com/webtrunk/calllink?code=T0NqdENma3h5YmczYVVia2xFRHpWSzRFcDJvN3ozVzI=';

  // Función para determinar si estamos en horario NO hábil (Colombia UTC-5)
  // Horario hábil: 8am - 6pm. Horario NO hábil: 6pm - 8am.
  const isNonBusinessHours = () => {
    try {
      // Obtenemos la hora actual específicamente en la zona horaria de Bogotá
      const bogotaHour = dayjs().tz('America/Bogota').hour();

      // Visible si es >= 18 (6pm) o < 8 (antes de las 8am)
      return bogotaHour >= 18 || bogotaHour < 8;
    } catch (e) {
      console.error('Error calculating Bogota time with DayJS:', e);
      return true; // Por seguridad, mostrar si falla el cálculo
    }
  };

  const handleCall = () => {
    // Abrimos la interfaz en una ventana emergente con dimensiones de teléfono
    window.open(
      callUrl,
      'NUA_Phone',
      'width=400,height=600,menubar=no,status=no,location=no,toolbar=no,resizable=yes',
    );
  };

  if (!isNonBusinessHours()) {
    return null;
  }

  return (
    <div className="click-to-call-widget" style={{ zIndex: 1000 }}>
      <FloatButton
        icon={<PhoneOutlined />}
        type="primary"
        style={{ right: 'calc(1vw + 14px)', bottom: 124, width: 60, height: 60 }} // centrado sobre el botón de ayuda
        tooltip={<div>Click para Llamar (Horario No Hábil)</div>}
        onClick={handleCall}
      />
    </div>
  );
};

export default ClickToCallWidget;
